import "./Footer.css"

const Footer = () => {
  return (
      <footer>
      <p className="text-white">© CopyRight 2024 | OnurKapucu</p>
    </footer>
  )
}

export default Footer
